import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import styles from "./Bubble.local.scss";
import IconLoader from "../../Icons/IconLoader";

export default class BubbleComponent extends PureComponent {
  static propTypes = {
    bubble: PropTypes.object.isRequired,
    onClickBubble: PropTypes.func
  };

  render() {
    const { bubble, onClickBubble, masking, archiving } = this.props;
    const classes = classnames(
      styles.bubble,
      styles[bubble.icon],
      bubble.disabled ? styles["disabled"] : "",
      {
        "d-none": bubble.hidden
      }
    );

    return (
      <div className={classes} onClick={onClickBubble}>
        <span className={styles.label}>
          {masking && bubble.icon === "i-mask" && <IconLoader width={26} />}
          {archiving &&
            bubble.icon === "i-archive" && <IconLoader width={26} />}
          {bubble.label}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BubblesList/Bubble/BubbleComponent.js